import { ForwardOutlined } from "@ant-design/icons";
import { Flex, Grid, Switch, Typography } from "antd";
import { ScopeContext } from "components/Assessment/contexts/ScopeContext";
import { GraphTooltip } from "components/GraphTooltip";
import { useContext } from "react";

type LateralMovementToggleProps = {
  checked: boolean;
  disabled: boolean;
  onChange: (includeLateral: boolean) => void;
};

export const LateralMovementToggle: React.FC<LateralMovementToggleProps> = ({
  checked,
  disabled,
  onChange,
}) => {
  const { md } = Grid.useBreakpoint();
  const { provider } = useContext(ScopeContext);

  return provider === "all" ? (
    <Flex align="center" gap="small">
      <GraphTooltip title="Include lateral movement to other identities. Searches may take longer and return larger, more complex paths.">
        <Flex align="center" gap="small">
          <ForwardOutlined style={{ fontSize: "20px" }} />
          {md && <Typography.Text>Lateral Movement</Typography.Text>}
        </Flex>
      </GraphTooltip>
      <Switch checked={checked} disabled={disabled} onChange={onChange} />
    </Flex>
  ) : null;
};
